<template>
  <span class="back-button" @click.prevent="$emit('back')">
    <icon :name="backIconName" />
  </span>
</template>

<script>
  export default {
    computed: {
      backIconName() {
        return this.$i18n.locale === 'en' ? 'arrow-circle-left' : 'arrow-circle-right';
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../variables';
  .back-button {
    cursor: pointer;
    color: $gray-500;
    &:hover {
      color: $gray-100;
    }
  }
</style>
